import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-complete',
  templateUrl: './complete.component.html',
  styleUrls: ['./complete.component.scss']
})
export class CompleteComponent implements OnInit {

  survey;
  surveyOutro: string;
  
  constructor() { }

  ngOnInit() {
    // Set survey
    let survey = sessionStorage.getItem("survey");
    if (survey) {
      this.survey = JSON.parse(survey);
    }
    sessionStorage.removeItem("survey");

    this.surveyOutro = this.survey ? this.survey.surveyOutro : null;
  }

}
